import React from 'react';
import PropTypes from 'prop-types';
import { 
  Button, 
  useTheme, 
  useMediaQuery, 
  Badge,
  styled,
  Zoom
} from '@mui/material';
import FilterList from '@mui/icons-material/FilterList';
import Tune from '@mui/icons-material/Tune';
import { useTranslation } from 'react-i18next';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -4,
    top: 8,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    fontWeight: 600
  },
}));

const FilterButton = ({ onFilter, badgeContent }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledBadge 
      badgeContent={badgeContent} 
      color="secondary"
      invisible={badgeContent === 0}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={onFilter}
        startIcon={
          <Zoom in>
            {isMediumScreen ? <Tune fontSize="small" /> : <FilterList fontSize="small" />}
          </Zoom>
        }
        sx={{
          width: '100%',
          borderRadius: 3,
          py: 1,
          border: `1px solid ${theme.palette.divider}`,
          '&:hover': {
            borderColor: theme.palette.primary.main,
          }
        }}
        aria-label={`Apply filters (${badgeContent} active)`}
      >
        {isMediumScreen ? t('Filters') : t('FilterOptions')}
      </Button>
    </StyledBadge>
  );
};

FilterButton.propTypes = {
  onFilter: PropTypes.func.isRequired,
  badgeContent: PropTypes.number,
};

FilterButton.defaultProps = {
  badgeContent: 0,
};

export default FilterButton;